import styled from 'styled-components';

export const Text = styled.div`
  font-size: 14px;
  color: ${props => props.theme.text};
`;

export const Bold = styled(Text)`
  font-weight: bold;
`;
